import React from 'react';

const Interactive = () => (
  <svg viewBox="0 0 70 45">
    <g fill="none" fillRule="evenodd">
      <rect fill="#409FFF" width="70" height="45" rx="5" />
      <circle fill="#FFF" opacity=".2" cx="27" cy="22" r="10" />
      <circle fill="#FFF" opacity=".4" cx="35" cy="22" r="10" />
      <circle fill="#FFF" cx="42" cy="22" r="10" />
    </g>
  </svg>
);

export default Interactive;
